import { getApi } from 'api/utils';

const api = getApi();

export const logRefCode = (refCode: string, checkCode: string) =>
  api.logRefCode(refCode, checkCode);
